/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as VerifyCourseWishlistRouteImport } from "./routes/verify-course-wishlist"
import { Route as TermsRouteImport } from "./routes/terms"
import { Route as PrivacyRouteImport } from "./routes/privacy"
import { Route as DownloadsRouteImport } from "./routes/downloads"
import { Route as CookiesRouteImport } from "./routes/cookies"
import { Route as SupportRouteRouteImport } from "./routes/support/route"
import { Route as AuthenticatedRouteRouteImport } from "./routes/_authenticated/route"
import { Route as authRouteRouteImport } from "./routes/(auth)/route"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as SupportIndexRouteImport } from "./routes/support/index"
import { Route as BlogIndexRouteImport } from "./routes/blog/index"
import { Route as SupportCreateTicketRouteImport } from "./routes/support/create-ticket"
import { Route as BlogSlugRouteImport } from "./routes/blog/$slug"
import { Route as AuthenticatedSyncStatusRouteImport } from "./routes/_authenticated/sync-status"
import { Route as AuthenticatedPurchasesRouteImport } from "./routes/_authenticated/purchases"
import { Route as AuthenticatedProfileRouteImport } from "./routes/_authenticated/profile"
import { Route as AuthenticatedNotificationsRouteImport } from "./routes/_authenticated/notifications"
import { Route as AuthenticatedDataExportRouteImport } from "./routes/_authenticated/data-export"
import { Route as AuthenticatedDashboardRouteImport } from "./routes/_authenticated/dashboard"
import { Route as AuthenticatedChatRouteImport } from "./routes/_authenticated/chat"
import { Route as AuthenticatedAccountRouteImport } from "./routes/_authenticated/account"
import { Route as authSignupRouteImport } from "./routes/(auth)/signup"
import { Route as authSigninRouteImport } from "./routes/(auth)/signin"
import { Route as authResetPasswordRouteImport } from "./routes/(auth)/reset-password"
import { Route as EducationCoursesRouteRouteImport } from "./routes/education/courses/route"
import { Route as AuthenticatedAdminRouteRouteImport } from "./routes/_authenticated/admin/route"
import { Route as SupportSupportTicketIndexRouteImport } from "./routes/support/$supportTicket/index"
import { Route as EducationCoursesIndexRouteImport } from "./routes/education/courses/index"
import { Route as AuthenticatedCoursesCourseIdRouteImport } from "./routes/_authenticated/courses.$courseId"
import { Route as AuthenticatedChatChannelIdRouteImport } from "./routes/_authenticated/chat.$channelId"
import { Route as AuthenticatedAdminUsersRouteImport } from "./routes/_authenticated/admin/users"
import { Route as AuthenticatedAdminStatsRouteImport } from "./routes/_authenticated/admin/stats"
import { Route as AuthenticatedAdminReviewsRouteImport } from "./routes/_authenticated/admin/reviews"
import { Route as AuthenticatedAdminPurchasesRouteImport } from "./routes/_authenticated/admin/purchases"
import { Route as AuthenticatedAdminProgressRouteImport } from "./routes/_authenticated/admin/progress"
import { Route as AuthenticatedAdminEnrollmentsRouteImport } from "./routes/_authenticated/admin/enrollments"
import { Route as AuthenticatedAdminEarlySignupsRouteImport } from "./routes/_authenticated/admin/early-signups"
import { Route as AuthenticatedAdminChatReportsRouteImport } from "./routes/_authenticated/admin/chat-reports"
import { Route as AuthenticatedAdminAuditRouteImport } from "./routes/_authenticated/admin/audit"
import { Route as AuthenticatedAdminAnnouncementsRouteImport } from "./routes/_authenticated/admin/announcements"
import { Route as authVerifyEmailTokenRouteImport } from "./routes/(auth)/verify-email.$token"
import { Route as SupportSupportTicketEditRouteRouteImport } from "./routes/support/$supportTicket/edit/route"
import { Route as EducationCoursesCourseRouteRouteImport } from "./routes/education/courses/$course/route"
import { Route as SupportSupportTicketEditIndexRouteImport } from "./routes/support/$supportTicket/edit/index"
import { Route as EducationCoursesCourseIndexRouteImport } from "./routes/education/courses/$course/index"
import { Route as AuthenticatedAdminCoursesIndexRouteImport } from "./routes/_authenticated/admin/courses/index"
import { Route as AuthenticatedAdminCouponsIndexRouteImport } from "./routes/_authenticated/admin/coupons/index"
import { Route as AuthenticatedCoursesCourseIdLessonsRouteImport } from "./routes/_authenticated/courses.$courseId.lessons"
import { Route as AuthenticatedChatSupportNewRouteImport } from "./routes/_authenticated/chat.support.new"
import { Route as AuthenticatedChatSupportCourseSlugRouteImport } from "./routes/_authenticated/chat.support.$courseSlug"
import { Route as AuthenticatedChatDmConversationIdRouteImport } from "./routes/_authenticated/chat.dm.$conversationId"
import { Route as AuthenticatedAdminCoursesInstructorNotesRouteImport } from "./routes/_authenticated/admin/courses.instructor-notes"
import { Route as AuthenticatedAdminCoursesFaqRouteImport } from "./routes/_authenticated/admin/courses.faq"
import { Route as AuthenticatedAdminCoursesCreateRouteImport } from "./routes/_authenticated/admin/courses/create"
import { Route as AuthenticatedCoursesCourseIdLessonsLessonIdRouteImport } from "./routes/_authenticated/courses.$courseId.lessons.$lessonId"
import { Route as AuthenticatedAdminCoursesCourseIdEditRouteImport } from "./routes/_authenticated/admin/courses/$courseId/edit"

const VerifyCourseWishlistRoute = VerifyCourseWishlistRouteImport.update({
  id: "/verify-course-wishlist",
  path: "/verify-course-wishlist",
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: "/terms",
  path: "/terms",
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadsRoute = DownloadsRouteImport.update({
  id: "/downloads",
  path: "/downloads",
  getParentRoute: () => rootRouteImport,
} as any)
const CookiesRoute = CookiesRouteImport.update({
  id: "/cookies",
  path: "/cookies",
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRouteRoute = SupportRouteRouteImport.update({
  id: "/support",
  path: "/support",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: "/(auth)",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const SupportIndexRoute = SupportIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => SupportRouteRoute,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: "/blog/",
  path: "/blog/",
  getParentRoute: () => rootRouteImport,
} as any)
const SupportCreateTicketRoute = SupportCreateTicketRouteImport.update({
  id: "/create-ticket",
  path: "/create-ticket",
  getParentRoute: () => SupportRouteRoute,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: "/blog/$slug",
  path: "/blog/$slug",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSyncStatusRoute = AuthenticatedSyncStatusRouteImport.update({
  id: "/sync-status",
  path: "/sync-status",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedPurchasesRoute = AuthenticatedPurchasesRouteImport.update({
  id: "/purchases",
  path: "/purchases",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: "/notifications",
    path: "/notifications",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDataExportRoute = AuthenticatedDataExportRouteImport.update({
  id: "/data-export",
  path: "/data-export",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedChatRoute = AuthenticatedChatRouteImport.update({
  id: "/chat",
  path: "/chat",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const authSignupRoute = authSignupRouteImport.update({
  id: "/signup",
  path: "/signup",
  getParentRoute: () => authRouteRoute,
} as any)
const authSigninRoute = authSigninRouteImport.update({
  id: "/signin",
  path: "/signin",
  getParentRoute: () => authRouteRoute,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => authRouteRoute,
} as any)
const EducationCoursesRouteRoute = EducationCoursesRouteRouteImport.update({
  id: "/education/courses",
  path: "/education/courses",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const SupportSupportTicketIndexRoute =
  SupportSupportTicketIndexRouteImport.update({
    id: "/$supportTicket/",
    path: "/$supportTicket/",
    getParentRoute: () => SupportRouteRoute,
  } as any)
const EducationCoursesIndexRoute = EducationCoursesIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => EducationCoursesRouteRoute,
} as any)
const AuthenticatedCoursesCourseIdRoute =
  AuthenticatedCoursesCourseIdRouteImport.update({
    id: "/courses/$courseId",
    path: "/courses/$courseId",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatChannelIdRoute =
  AuthenticatedChatChannelIdRouteImport.update({
    id: "/$channelId",
    path: "/$channelId",
    getParentRoute: () => AuthenticatedChatRoute,
  } as any)
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
  id: "/users",
  path: "/users",
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminStatsRoute = AuthenticatedAdminStatsRouteImport.update({
  id: "/stats",
  path: "/stats",
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminReviewsRoute =
  AuthenticatedAdminReviewsRouteImport.update({
    id: "/reviews",
    path: "/reviews",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminPurchasesRoute =
  AuthenticatedAdminPurchasesRouteImport.update({
    id: "/purchases",
    path: "/purchases",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminProgressRoute =
  AuthenticatedAdminProgressRouteImport.update({
    id: "/progress",
    path: "/progress",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminEnrollmentsRoute =
  AuthenticatedAdminEnrollmentsRouteImport.update({
    id: "/enrollments",
    path: "/enrollments",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminEarlySignupsRoute =
  AuthenticatedAdminEarlySignupsRouteImport.update({
    id: "/early-signups",
    path: "/early-signups",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminChatReportsRoute =
  AuthenticatedAdminChatReportsRouteImport.update({
    id: "/chat-reports",
    path: "/chat-reports",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
  id: "/audit",
  path: "/audit",
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminAnnouncementsRoute =
  AuthenticatedAdminAnnouncementsRouteImport.update({
    id: "/announcements",
    path: "/announcements",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const authVerifyEmailTokenRoute = authVerifyEmailTokenRouteImport.update({
  id: "/verify-email/$token",
  path: "/verify-email/$token",
  getParentRoute: () => authRouteRoute,
} as any)
const SupportSupportTicketEditRouteRoute =
  SupportSupportTicketEditRouteRouteImport.update({
    id: "/$supportTicket/edit",
    path: "/$supportTicket/edit",
    getParentRoute: () => SupportRouteRoute,
  } as any)
const EducationCoursesCourseRouteRoute =
  EducationCoursesCourseRouteRouteImport.update({
    id: "/$course",
    path: "/$course",
    getParentRoute: () => EducationCoursesRouteRoute,
  } as any)
const SupportSupportTicketEditIndexRoute =
  SupportSupportTicketEditIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => SupportSupportTicketEditRouteRoute,
  } as any)
const EducationCoursesCourseIndexRoute =
  EducationCoursesCourseIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => EducationCoursesCourseRouteRoute,
  } as any)
const AuthenticatedAdminCoursesIndexRoute =
  AuthenticatedAdminCoursesIndexRouteImport.update({
    id: "/courses/",
    path: "/courses/",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminCouponsIndexRoute =
  AuthenticatedAdminCouponsIndexRouteImport.update({
    id: "/coupons/",
    path: "/coupons/",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedCoursesCourseIdLessonsRoute =
  AuthenticatedCoursesCourseIdLessonsRouteImport.update({
    id: "/lessons",
    path: "/lessons",
    getParentRoute: () => AuthenticatedCoursesCourseIdRoute,
  } as any)
const AuthenticatedChatSupportNewRoute =
  AuthenticatedChatSupportNewRouteImport.update({
    id: "/support/new",
    path: "/support/new",
    getParentRoute: () => AuthenticatedChatRoute,
  } as any)
const AuthenticatedChatSupportCourseSlugRoute =
  AuthenticatedChatSupportCourseSlugRouteImport.update({
    id: "/support/$courseSlug",
    path: "/support/$courseSlug",
    getParentRoute: () => AuthenticatedChatRoute,
  } as any)
const AuthenticatedChatDmConversationIdRoute =
  AuthenticatedChatDmConversationIdRouteImport.update({
    id: "/dm/$conversationId",
    path: "/dm/$conversationId",
    getParentRoute: () => AuthenticatedChatRoute,
  } as any)
const AuthenticatedAdminCoursesInstructorNotesRoute =
  AuthenticatedAdminCoursesInstructorNotesRouteImport.update({
    id: "/courses/instructor-notes",
    path: "/courses/instructor-notes",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminCoursesFaqRoute =
  AuthenticatedAdminCoursesFaqRouteImport.update({
    id: "/courses/faq",
    path: "/courses/faq",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminCoursesCreateRoute =
  AuthenticatedAdminCoursesCreateRouteImport.update({
    id: "/courses/create",
    path: "/courses/create",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedCoursesCourseIdLessonsLessonIdRoute =
  AuthenticatedCoursesCourseIdLessonsLessonIdRouteImport.update({
    id: "/$lessonId",
    path: "/$lessonId",
    getParentRoute: () => AuthenticatedCoursesCourseIdLessonsRoute,
  } as any)
const AuthenticatedAdminCoursesCourseIdEditRoute =
  AuthenticatedAdminCoursesCourseIdEditRouteImport.update({
    id: "/courses/$courseId/edit",
    path: "/courses/$courseId/edit",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/support": typeof SupportRouteRouteWithChildren
  "/cookies": typeof CookiesRoute
  "/downloads": typeof DownloadsRoute
  "/privacy": typeof PrivacyRoute
  "/terms": typeof TermsRoute
  "/verify-course-wishlist": typeof VerifyCourseWishlistRoute
  "/admin": typeof AuthenticatedAdminRouteRouteWithChildren
  "/education/courses": typeof EducationCoursesRouteRouteWithChildren
  "/reset-password": typeof authResetPasswordRoute
  "/signin": typeof authSigninRoute
  "/signup": typeof authSignupRoute
  "/account": typeof AuthenticatedAccountRoute
  "/chat": typeof AuthenticatedChatRouteWithChildren
  "/dashboard": typeof AuthenticatedDashboardRoute
  "/data-export": typeof AuthenticatedDataExportRoute
  "/notifications": typeof AuthenticatedNotificationsRoute
  "/profile": typeof AuthenticatedProfileRoute
  "/purchases": typeof AuthenticatedPurchasesRoute
  "/sync-status": typeof AuthenticatedSyncStatusRoute
  "/blog/$slug": typeof BlogSlugRoute
  "/support/create-ticket": typeof SupportCreateTicketRoute
  "/blog/": typeof BlogIndexRoute
  "/support/": typeof SupportIndexRoute
  "/education/courses/$course": typeof EducationCoursesCourseRouteRouteWithChildren
  "/support/$supportTicket/edit": typeof SupportSupportTicketEditRouteRouteWithChildren
  "/verify-email/$token": typeof authVerifyEmailTokenRoute
  "/admin/announcements": typeof AuthenticatedAdminAnnouncementsRoute
  "/admin/audit": typeof AuthenticatedAdminAuditRoute
  "/admin/chat-reports": typeof AuthenticatedAdminChatReportsRoute
  "/admin/early-signups": typeof AuthenticatedAdminEarlySignupsRoute
  "/admin/enrollments": typeof AuthenticatedAdminEnrollmentsRoute
  "/admin/progress": typeof AuthenticatedAdminProgressRoute
  "/admin/purchases": typeof AuthenticatedAdminPurchasesRoute
  "/admin/reviews": typeof AuthenticatedAdminReviewsRoute
  "/admin/stats": typeof AuthenticatedAdminStatsRoute
  "/admin/users": typeof AuthenticatedAdminUsersRoute
  "/chat/$channelId": typeof AuthenticatedChatChannelIdRoute
  "/courses/$courseId": typeof AuthenticatedCoursesCourseIdRouteWithChildren
  "/education/courses/": typeof EducationCoursesIndexRoute
  "/support/$supportTicket/": typeof SupportSupportTicketIndexRoute
  "/admin/courses/create": typeof AuthenticatedAdminCoursesCreateRoute
  "/admin/courses/faq": typeof AuthenticatedAdminCoursesFaqRoute
  "/admin/courses/instructor-notes": typeof AuthenticatedAdminCoursesInstructorNotesRoute
  "/chat/dm/$conversationId": typeof AuthenticatedChatDmConversationIdRoute
  "/chat/support/$courseSlug": typeof AuthenticatedChatSupportCourseSlugRoute
  "/chat/support/new": typeof AuthenticatedChatSupportNewRoute
  "/courses/$courseId/lessons": typeof AuthenticatedCoursesCourseIdLessonsRouteWithChildren
  "/admin/coupons/": typeof AuthenticatedAdminCouponsIndexRoute
  "/admin/courses/": typeof AuthenticatedAdminCoursesIndexRoute
  "/education/courses/$course/": typeof EducationCoursesCourseIndexRoute
  "/support/$supportTicket/edit/": typeof SupportSupportTicketEditIndexRoute
  "/admin/courses/$courseId/edit": typeof AuthenticatedAdminCoursesCourseIdEditRoute
  "/courses/$courseId/lessons/$lessonId": typeof AuthenticatedCoursesCourseIdLessonsLessonIdRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/cookies": typeof CookiesRoute
  "/downloads": typeof DownloadsRoute
  "/privacy": typeof PrivacyRoute
  "/terms": typeof TermsRoute
  "/verify-course-wishlist": typeof VerifyCourseWishlistRoute
  "/admin": typeof AuthenticatedAdminRouteRouteWithChildren
  "/reset-password": typeof authResetPasswordRoute
  "/signin": typeof authSigninRoute
  "/signup": typeof authSignupRoute
  "/account": typeof AuthenticatedAccountRoute
  "/chat": typeof AuthenticatedChatRouteWithChildren
  "/dashboard": typeof AuthenticatedDashboardRoute
  "/data-export": typeof AuthenticatedDataExportRoute
  "/notifications": typeof AuthenticatedNotificationsRoute
  "/profile": typeof AuthenticatedProfileRoute
  "/purchases": typeof AuthenticatedPurchasesRoute
  "/sync-status": typeof AuthenticatedSyncStatusRoute
  "/blog/$slug": typeof BlogSlugRoute
  "/support/create-ticket": typeof SupportCreateTicketRoute
  "/blog": typeof BlogIndexRoute
  "/support": typeof SupportIndexRoute
  "/verify-email/$token": typeof authVerifyEmailTokenRoute
  "/admin/announcements": typeof AuthenticatedAdminAnnouncementsRoute
  "/admin/audit": typeof AuthenticatedAdminAuditRoute
  "/admin/chat-reports": typeof AuthenticatedAdminChatReportsRoute
  "/admin/early-signups": typeof AuthenticatedAdminEarlySignupsRoute
  "/admin/enrollments": typeof AuthenticatedAdminEnrollmentsRoute
  "/admin/progress": typeof AuthenticatedAdminProgressRoute
  "/admin/purchases": typeof AuthenticatedAdminPurchasesRoute
  "/admin/reviews": typeof AuthenticatedAdminReviewsRoute
  "/admin/stats": typeof AuthenticatedAdminStatsRoute
  "/admin/users": typeof AuthenticatedAdminUsersRoute
  "/chat/$channelId": typeof AuthenticatedChatChannelIdRoute
  "/courses/$courseId": typeof AuthenticatedCoursesCourseIdRouteWithChildren
  "/education/courses": typeof EducationCoursesIndexRoute
  "/support/$supportTicket": typeof SupportSupportTicketIndexRoute
  "/admin/courses/create": typeof AuthenticatedAdminCoursesCreateRoute
  "/admin/courses/faq": typeof AuthenticatedAdminCoursesFaqRoute
  "/admin/courses/instructor-notes": typeof AuthenticatedAdminCoursesInstructorNotesRoute
  "/chat/dm/$conversationId": typeof AuthenticatedChatDmConversationIdRoute
  "/chat/support/$courseSlug": typeof AuthenticatedChatSupportCourseSlugRoute
  "/chat/support/new": typeof AuthenticatedChatSupportNewRoute
  "/courses/$courseId/lessons": typeof AuthenticatedCoursesCourseIdLessonsRouteWithChildren
  "/admin/coupons": typeof AuthenticatedAdminCouponsIndexRoute
  "/admin/courses": typeof AuthenticatedAdminCoursesIndexRoute
  "/education/courses/$course": typeof EducationCoursesCourseIndexRoute
  "/support/$supportTicket/edit": typeof SupportSupportTicketEditIndexRoute
  "/admin/courses/$courseId/edit": typeof AuthenticatedAdminCoursesCourseIdEditRoute
  "/courses/$courseId/lessons/$lessonId": typeof AuthenticatedCoursesCourseIdLessonsLessonIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/(auth)": typeof authRouteRouteWithChildren
  "/_authenticated": typeof AuthenticatedRouteRouteWithChildren
  "/support": typeof SupportRouteRouteWithChildren
  "/cookies": typeof CookiesRoute
  "/downloads": typeof DownloadsRoute
  "/privacy": typeof PrivacyRoute
  "/terms": typeof TermsRoute
  "/verify-course-wishlist": typeof VerifyCourseWishlistRoute
  "/_authenticated/admin": typeof AuthenticatedAdminRouteRouteWithChildren
  "/education/courses": typeof EducationCoursesRouteRouteWithChildren
  "/(auth)/reset-password": typeof authResetPasswordRoute
  "/(auth)/signin": typeof authSigninRoute
  "/(auth)/signup": typeof authSignupRoute
  "/_authenticated/account": typeof AuthenticatedAccountRoute
  "/_authenticated/chat": typeof AuthenticatedChatRouteWithChildren
  "/_authenticated/dashboard": typeof AuthenticatedDashboardRoute
  "/_authenticated/data-export": typeof AuthenticatedDataExportRoute
  "/_authenticated/notifications": typeof AuthenticatedNotificationsRoute
  "/_authenticated/profile": typeof AuthenticatedProfileRoute
  "/_authenticated/purchases": typeof AuthenticatedPurchasesRoute
  "/_authenticated/sync-status": typeof AuthenticatedSyncStatusRoute
  "/blog/$slug": typeof BlogSlugRoute
  "/support/create-ticket": typeof SupportCreateTicketRoute
  "/blog/": typeof BlogIndexRoute
  "/support/": typeof SupportIndexRoute
  "/education/courses/$course": typeof EducationCoursesCourseRouteRouteWithChildren
  "/support/$supportTicket/edit": typeof SupportSupportTicketEditRouteRouteWithChildren
  "/(auth)/verify-email/$token": typeof authVerifyEmailTokenRoute
  "/_authenticated/admin/announcements": typeof AuthenticatedAdminAnnouncementsRoute
  "/_authenticated/admin/audit": typeof AuthenticatedAdminAuditRoute
  "/_authenticated/admin/chat-reports": typeof AuthenticatedAdminChatReportsRoute
  "/_authenticated/admin/early-signups": typeof AuthenticatedAdminEarlySignupsRoute
  "/_authenticated/admin/enrollments": typeof AuthenticatedAdminEnrollmentsRoute
  "/_authenticated/admin/progress": typeof AuthenticatedAdminProgressRoute
  "/_authenticated/admin/purchases": typeof AuthenticatedAdminPurchasesRoute
  "/_authenticated/admin/reviews": typeof AuthenticatedAdminReviewsRoute
  "/_authenticated/admin/stats": typeof AuthenticatedAdminStatsRoute
  "/_authenticated/admin/users": typeof AuthenticatedAdminUsersRoute
  "/_authenticated/chat/$channelId": typeof AuthenticatedChatChannelIdRoute
  "/_authenticated/courses/$courseId": typeof AuthenticatedCoursesCourseIdRouteWithChildren
  "/education/courses/": typeof EducationCoursesIndexRoute
  "/support/$supportTicket/": typeof SupportSupportTicketIndexRoute
  "/_authenticated/admin/courses/create": typeof AuthenticatedAdminCoursesCreateRoute
  "/_authenticated/admin/courses/faq": typeof AuthenticatedAdminCoursesFaqRoute
  "/_authenticated/admin/courses/instructor-notes": typeof AuthenticatedAdminCoursesInstructorNotesRoute
  "/_authenticated/chat/dm/$conversationId": typeof AuthenticatedChatDmConversationIdRoute
  "/_authenticated/chat/support/$courseSlug": typeof AuthenticatedChatSupportCourseSlugRoute
  "/_authenticated/chat/support/new": typeof AuthenticatedChatSupportNewRoute
  "/_authenticated/courses/$courseId/lessons": typeof AuthenticatedCoursesCourseIdLessonsRouteWithChildren
  "/_authenticated/admin/coupons/": typeof AuthenticatedAdminCouponsIndexRoute
  "/_authenticated/admin/courses/": typeof AuthenticatedAdminCoursesIndexRoute
  "/education/courses/$course/": typeof EducationCoursesCourseIndexRoute
  "/support/$supportTicket/edit/": typeof SupportSupportTicketEditIndexRoute
  "/_authenticated/admin/courses/$courseId/edit": typeof AuthenticatedAdminCoursesCourseIdEditRoute
  "/_authenticated/courses/$courseId/lessons/$lessonId": typeof AuthenticatedCoursesCourseIdLessonsLessonIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/support"
    | "/cookies"
    | "/downloads"
    | "/privacy"
    | "/terms"
    | "/verify-course-wishlist"
    | "/admin"
    | "/education/courses"
    | "/reset-password"
    | "/signin"
    | "/signup"
    | "/account"
    | "/chat"
    | "/dashboard"
    | "/data-export"
    | "/notifications"
    | "/profile"
    | "/purchases"
    | "/sync-status"
    | "/blog/$slug"
    | "/support/create-ticket"
    | "/blog/"
    | "/support/"
    | "/education/courses/$course"
    | "/support/$supportTicket/edit"
    | "/verify-email/$token"
    | "/admin/announcements"
    | "/admin/audit"
    | "/admin/chat-reports"
    | "/admin/early-signups"
    | "/admin/enrollments"
    | "/admin/progress"
    | "/admin/purchases"
    | "/admin/reviews"
    | "/admin/stats"
    | "/admin/users"
    | "/chat/$channelId"
    | "/courses/$courseId"
    | "/education/courses/"
    | "/support/$supportTicket/"
    | "/admin/courses/create"
    | "/admin/courses/faq"
    | "/admin/courses/instructor-notes"
    | "/chat/dm/$conversationId"
    | "/chat/support/$courseSlug"
    | "/chat/support/new"
    | "/courses/$courseId/lessons"
    | "/admin/coupons/"
    | "/admin/courses/"
    | "/education/courses/$course/"
    | "/support/$supportTicket/edit/"
    | "/admin/courses/$courseId/edit"
    | "/courses/$courseId/lessons/$lessonId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/cookies"
    | "/downloads"
    | "/privacy"
    | "/terms"
    | "/verify-course-wishlist"
    | "/admin"
    | "/reset-password"
    | "/signin"
    | "/signup"
    | "/account"
    | "/chat"
    | "/dashboard"
    | "/data-export"
    | "/notifications"
    | "/profile"
    | "/purchases"
    | "/sync-status"
    | "/blog/$slug"
    | "/support/create-ticket"
    | "/blog"
    | "/support"
    | "/verify-email/$token"
    | "/admin/announcements"
    | "/admin/audit"
    | "/admin/chat-reports"
    | "/admin/early-signups"
    | "/admin/enrollments"
    | "/admin/progress"
    | "/admin/purchases"
    | "/admin/reviews"
    | "/admin/stats"
    | "/admin/users"
    | "/chat/$channelId"
    | "/courses/$courseId"
    | "/education/courses"
    | "/support/$supportTicket"
    | "/admin/courses/create"
    | "/admin/courses/faq"
    | "/admin/courses/instructor-notes"
    | "/chat/dm/$conversationId"
    | "/chat/support/$courseSlug"
    | "/chat/support/new"
    | "/courses/$courseId/lessons"
    | "/admin/coupons"
    | "/admin/courses"
    | "/education/courses/$course"
    | "/support/$supportTicket/edit"
    | "/admin/courses/$courseId/edit"
    | "/courses/$courseId/lessons/$lessonId"
  id:
    | "__root__"
    | "/"
    | "/(auth)"
    | "/_authenticated"
    | "/support"
    | "/cookies"
    | "/downloads"
    | "/privacy"
    | "/terms"
    | "/verify-course-wishlist"
    | "/_authenticated/admin"
    | "/education/courses"
    | "/(auth)/reset-password"
    | "/(auth)/signin"
    | "/(auth)/signup"
    | "/_authenticated/account"
    | "/_authenticated/chat"
    | "/_authenticated/dashboard"
    | "/_authenticated/data-export"
    | "/_authenticated/notifications"
    | "/_authenticated/profile"
    | "/_authenticated/purchases"
    | "/_authenticated/sync-status"
    | "/blog/$slug"
    | "/support/create-ticket"
    | "/blog/"
    | "/support/"
    | "/education/courses/$course"
    | "/support/$supportTicket/edit"
    | "/(auth)/verify-email/$token"
    | "/_authenticated/admin/announcements"
    | "/_authenticated/admin/audit"
    | "/_authenticated/admin/chat-reports"
    | "/_authenticated/admin/early-signups"
    | "/_authenticated/admin/enrollments"
    | "/_authenticated/admin/progress"
    | "/_authenticated/admin/purchases"
    | "/_authenticated/admin/reviews"
    | "/_authenticated/admin/stats"
    | "/_authenticated/admin/users"
    | "/_authenticated/chat/$channelId"
    | "/_authenticated/courses/$courseId"
    | "/education/courses/"
    | "/support/$supportTicket/"
    | "/_authenticated/admin/courses/create"
    | "/_authenticated/admin/courses/faq"
    | "/_authenticated/admin/courses/instructor-notes"
    | "/_authenticated/chat/dm/$conversationId"
    | "/_authenticated/chat/support/$courseSlug"
    | "/_authenticated/chat/support/new"
    | "/_authenticated/courses/$courseId/lessons"
    | "/_authenticated/admin/coupons/"
    | "/_authenticated/admin/courses/"
    | "/education/courses/$course/"
    | "/support/$supportTicket/edit/"
    | "/_authenticated/admin/courses/$courseId/edit"
    | "/_authenticated/courses/$courseId/lessons/$lessonId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  authRouteRoute: typeof authRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  SupportRouteRoute: typeof SupportRouteRouteWithChildren
  CookiesRoute: typeof CookiesRoute
  DownloadsRoute: typeof DownloadsRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  VerifyCourseWishlistRoute: typeof VerifyCourseWishlistRoute
  EducationCoursesRouteRoute: typeof EducationCoursesRouteRouteWithChildren
  BlogSlugRoute: typeof BlogSlugRoute
  BlogIndexRoute: typeof BlogIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/verify-course-wishlist": {
      id: "/verify-course-wishlist"
      path: "/verify-course-wishlist"
      fullPath: "/verify-course-wishlist"
      preLoaderRoute: typeof VerifyCourseWishlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/terms": {
      id: "/terms"
      path: "/terms"
      fullPath: "/terms"
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/privacy": {
      id: "/privacy"
      path: "/privacy"
      fullPath: "/privacy"
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/downloads": {
      id: "/downloads"
      path: "/downloads"
      fullPath: "/downloads"
      preLoaderRoute: typeof DownloadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/cookies": {
      id: "/cookies"
      path: "/cookies"
      fullPath: "/cookies"
      preLoaderRoute: typeof CookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/support": {
      id: "/support"
      path: "/support"
      fullPath: "/support"
      preLoaderRoute: typeof SupportRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(auth)": {
      id: "/(auth)"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/support/": {
      id: "/support/"
      path: "/"
      fullPath: "/support/"
      preLoaderRoute: typeof SupportIndexRouteImport
      parentRoute: typeof SupportRouteRoute
    }
    "/blog/": {
      id: "/blog/"
      path: "/blog"
      fullPath: "/blog/"
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/support/create-ticket": {
      id: "/support/create-ticket"
      path: "/create-ticket"
      fullPath: "/support/create-ticket"
      preLoaderRoute: typeof SupportCreateTicketRouteImport
      parentRoute: typeof SupportRouteRoute
    }
    "/blog/$slug": {
      id: "/blog/$slug"
      path: "/blog/$slug"
      fullPath: "/blog/$slug"
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/sync-status": {
      id: "/_authenticated/sync-status"
      path: "/sync-status"
      fullPath: "/sync-status"
      preLoaderRoute: typeof AuthenticatedSyncStatusRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    "/_authenticated/purchases": {
      id: "/_authenticated/purchases"
      path: "/purchases"
      fullPath: "/purchases"
      preLoaderRoute: typeof AuthenticatedPurchasesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    "/_authenticated/profile": {
      id: "/_authenticated/profile"
      path: "/profile"
      fullPath: "/profile"
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    "/_authenticated/notifications": {
      id: "/_authenticated/notifications"
      path: "/notifications"
      fullPath: "/notifications"
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    "/_authenticated/data-export": {
      id: "/_authenticated/data-export"
      path: "/data-export"
      fullPath: "/data-export"
      preLoaderRoute: typeof AuthenticatedDataExportRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    "/_authenticated/dashboard": {
      id: "/_authenticated/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    "/_authenticated/chat": {
      id: "/_authenticated/chat"
      path: "/chat"
      fullPath: "/chat"
      preLoaderRoute: typeof AuthenticatedChatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    "/_authenticated/account": {
      id: "/_authenticated/account"
      path: "/account"
      fullPath: "/account"
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    "/(auth)/signup": {
      id: "/(auth)/signup"
      path: "/signup"
      fullPath: "/signup"
      preLoaderRoute: typeof authSignupRouteImport
      parentRoute: typeof authRouteRoute
    }
    "/(auth)/signin": {
      id: "/(auth)/signin"
      path: "/signin"
      fullPath: "/signin"
      preLoaderRoute: typeof authSigninRouteImport
      parentRoute: typeof authRouteRoute
    }
    "/(auth)/reset-password": {
      id: "/(auth)/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    "/education/courses": {
      id: "/education/courses"
      path: "/education/courses"
      fullPath: "/education/courses"
      preLoaderRoute: typeof EducationCoursesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/admin": {
      id: "/_authenticated/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AuthenticatedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    "/support/$supportTicket/": {
      id: "/support/$supportTicket/"
      path: "/$supportTicket"
      fullPath: "/support/$supportTicket/"
      preLoaderRoute: typeof SupportSupportTicketIndexRouteImport
      parentRoute: typeof SupportRouteRoute
    }
    "/education/courses/": {
      id: "/education/courses/"
      path: "/"
      fullPath: "/education/courses/"
      preLoaderRoute: typeof EducationCoursesIndexRouteImport
      parentRoute: typeof EducationCoursesRouteRoute
    }
    "/_authenticated/courses/$courseId": {
      id: "/_authenticated/courses/$courseId"
      path: "/courses/$courseId"
      fullPath: "/courses/$courseId"
      preLoaderRoute: typeof AuthenticatedCoursesCourseIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    "/_authenticated/chat/$channelId": {
      id: "/_authenticated/chat/$channelId"
      path: "/$channelId"
      fullPath: "/chat/$channelId"
      preLoaderRoute: typeof AuthenticatedChatChannelIdRouteImport
      parentRoute: typeof AuthenticatedChatRoute
    }
    "/_authenticated/admin/users": {
      id: "/_authenticated/admin/users"
      path: "/users"
      fullPath: "/admin/users"
      preLoaderRoute: typeof AuthenticatedAdminUsersRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/stats": {
      id: "/_authenticated/admin/stats"
      path: "/stats"
      fullPath: "/admin/stats"
      preLoaderRoute: typeof AuthenticatedAdminStatsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/reviews": {
      id: "/_authenticated/admin/reviews"
      path: "/reviews"
      fullPath: "/admin/reviews"
      preLoaderRoute: typeof AuthenticatedAdminReviewsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/purchases": {
      id: "/_authenticated/admin/purchases"
      path: "/purchases"
      fullPath: "/admin/purchases"
      preLoaderRoute: typeof AuthenticatedAdminPurchasesRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/progress": {
      id: "/_authenticated/admin/progress"
      path: "/progress"
      fullPath: "/admin/progress"
      preLoaderRoute: typeof AuthenticatedAdminProgressRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/enrollments": {
      id: "/_authenticated/admin/enrollments"
      path: "/enrollments"
      fullPath: "/admin/enrollments"
      preLoaderRoute: typeof AuthenticatedAdminEnrollmentsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/early-signups": {
      id: "/_authenticated/admin/early-signups"
      path: "/early-signups"
      fullPath: "/admin/early-signups"
      preLoaderRoute: typeof AuthenticatedAdminEarlySignupsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/chat-reports": {
      id: "/_authenticated/admin/chat-reports"
      path: "/chat-reports"
      fullPath: "/admin/chat-reports"
      preLoaderRoute: typeof AuthenticatedAdminChatReportsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/audit": {
      id: "/_authenticated/admin/audit"
      path: "/audit"
      fullPath: "/admin/audit"
      preLoaderRoute: typeof AuthenticatedAdminAuditRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/announcements": {
      id: "/_authenticated/admin/announcements"
      path: "/announcements"
      fullPath: "/admin/announcements"
      preLoaderRoute: typeof AuthenticatedAdminAnnouncementsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/(auth)/verify-email/$token": {
      id: "/(auth)/verify-email/$token"
      path: "/verify-email/$token"
      fullPath: "/verify-email/$token"
      preLoaderRoute: typeof authVerifyEmailTokenRouteImport
      parentRoute: typeof authRouteRoute
    }
    "/support/$supportTicket/edit": {
      id: "/support/$supportTicket/edit"
      path: "/$supportTicket/edit"
      fullPath: "/support/$supportTicket/edit"
      preLoaderRoute: typeof SupportSupportTicketEditRouteRouteImport
      parentRoute: typeof SupportRouteRoute
    }
    "/education/courses/$course": {
      id: "/education/courses/$course"
      path: "/$course"
      fullPath: "/education/courses/$course"
      preLoaderRoute: typeof EducationCoursesCourseRouteRouteImport
      parentRoute: typeof EducationCoursesRouteRoute
    }
    "/support/$supportTicket/edit/": {
      id: "/support/$supportTicket/edit/"
      path: "/"
      fullPath: "/support/$supportTicket/edit/"
      preLoaderRoute: typeof SupportSupportTicketEditIndexRouteImport
      parentRoute: typeof SupportSupportTicketEditRouteRoute
    }
    "/education/courses/$course/": {
      id: "/education/courses/$course/"
      path: "/"
      fullPath: "/education/courses/$course/"
      preLoaderRoute: typeof EducationCoursesCourseIndexRouteImport
      parentRoute: typeof EducationCoursesCourseRouteRoute
    }
    "/_authenticated/admin/courses/": {
      id: "/_authenticated/admin/courses/"
      path: "/courses"
      fullPath: "/admin/courses/"
      preLoaderRoute: typeof AuthenticatedAdminCoursesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/coupons/": {
      id: "/_authenticated/admin/coupons/"
      path: "/coupons"
      fullPath: "/admin/coupons/"
      preLoaderRoute: typeof AuthenticatedAdminCouponsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/courses/$courseId/lessons": {
      id: "/_authenticated/courses/$courseId/lessons"
      path: "/lessons"
      fullPath: "/courses/$courseId/lessons"
      preLoaderRoute: typeof AuthenticatedCoursesCourseIdLessonsRouteImport
      parentRoute: typeof AuthenticatedCoursesCourseIdRoute
    }
    "/_authenticated/chat/support/new": {
      id: "/_authenticated/chat/support/new"
      path: "/support/new"
      fullPath: "/chat/support/new"
      preLoaderRoute: typeof AuthenticatedChatSupportNewRouteImport
      parentRoute: typeof AuthenticatedChatRoute
    }
    "/_authenticated/chat/support/$courseSlug": {
      id: "/_authenticated/chat/support/$courseSlug"
      path: "/support/$courseSlug"
      fullPath: "/chat/support/$courseSlug"
      preLoaderRoute: typeof AuthenticatedChatSupportCourseSlugRouteImport
      parentRoute: typeof AuthenticatedChatRoute
    }
    "/_authenticated/chat/dm/$conversationId": {
      id: "/_authenticated/chat/dm/$conversationId"
      path: "/dm/$conversationId"
      fullPath: "/chat/dm/$conversationId"
      preLoaderRoute: typeof AuthenticatedChatDmConversationIdRouteImport
      parentRoute: typeof AuthenticatedChatRoute
    }
    "/_authenticated/admin/courses/instructor-notes": {
      id: "/_authenticated/admin/courses/instructor-notes"
      path: "/courses/instructor-notes"
      fullPath: "/admin/courses/instructor-notes"
      preLoaderRoute: typeof AuthenticatedAdminCoursesInstructorNotesRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/courses/faq": {
      id: "/_authenticated/admin/courses/faq"
      path: "/courses/faq"
      fullPath: "/admin/courses/faq"
      preLoaderRoute: typeof AuthenticatedAdminCoursesFaqRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/admin/courses/create": {
      id: "/_authenticated/admin/courses/create"
      path: "/courses/create"
      fullPath: "/admin/courses/create"
      preLoaderRoute: typeof AuthenticatedAdminCoursesCreateRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    "/_authenticated/courses/$courseId/lessons/$lessonId": {
      id: "/_authenticated/courses/$courseId/lessons/$lessonId"
      path: "/$lessonId"
      fullPath: "/courses/$courseId/lessons/$lessonId"
      preLoaderRoute: typeof AuthenticatedCoursesCourseIdLessonsLessonIdRouteImport
      parentRoute: typeof AuthenticatedCoursesCourseIdLessonsRoute
    }
    "/_authenticated/admin/courses/$courseId/edit": {
      id: "/_authenticated/admin/courses/$courseId/edit"
      path: "/courses/$courseId/edit"
      fullPath: "/admin/courses/$courseId/edit"
      preLoaderRoute: typeof AuthenticatedAdminCoursesCourseIdEditRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
  }
}

interface authRouteRouteChildren {
  authResetPasswordRoute: typeof authResetPasswordRoute
  authSigninRoute: typeof authSigninRoute
  authSignupRoute: typeof authSignupRoute
  authVerifyEmailTokenRoute: typeof authVerifyEmailTokenRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authResetPasswordRoute: authResetPasswordRoute,
  authSigninRoute: authSigninRoute,
  authSignupRoute: authSignupRoute,
  authVerifyEmailTokenRoute: authVerifyEmailTokenRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminAnnouncementsRoute: typeof AuthenticatedAdminAnnouncementsRoute
  AuthenticatedAdminAuditRoute: typeof AuthenticatedAdminAuditRoute
  AuthenticatedAdminChatReportsRoute: typeof AuthenticatedAdminChatReportsRoute
  AuthenticatedAdminEarlySignupsRoute: typeof AuthenticatedAdminEarlySignupsRoute
  AuthenticatedAdminEnrollmentsRoute: typeof AuthenticatedAdminEnrollmentsRoute
  AuthenticatedAdminProgressRoute: typeof AuthenticatedAdminProgressRoute
  AuthenticatedAdminPurchasesRoute: typeof AuthenticatedAdminPurchasesRoute
  AuthenticatedAdminReviewsRoute: typeof AuthenticatedAdminReviewsRoute
  AuthenticatedAdminStatsRoute: typeof AuthenticatedAdminStatsRoute
  AuthenticatedAdminUsersRoute: typeof AuthenticatedAdminUsersRoute
  AuthenticatedAdminCoursesCreateRoute: typeof AuthenticatedAdminCoursesCreateRoute
  AuthenticatedAdminCoursesFaqRoute: typeof AuthenticatedAdminCoursesFaqRoute
  AuthenticatedAdminCoursesInstructorNotesRoute: typeof AuthenticatedAdminCoursesInstructorNotesRoute
  AuthenticatedAdminCouponsIndexRoute: typeof AuthenticatedAdminCouponsIndexRoute
  AuthenticatedAdminCoursesIndexRoute: typeof AuthenticatedAdminCoursesIndexRoute
  AuthenticatedAdminCoursesCourseIdEditRoute: typeof AuthenticatedAdminCoursesCourseIdEditRoute
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminAnnouncementsRoute: AuthenticatedAdminAnnouncementsRoute,
    AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,
    AuthenticatedAdminChatReportsRoute: AuthenticatedAdminChatReportsRoute,
    AuthenticatedAdminEarlySignupsRoute: AuthenticatedAdminEarlySignupsRoute,
    AuthenticatedAdminEnrollmentsRoute: AuthenticatedAdminEnrollmentsRoute,
    AuthenticatedAdminProgressRoute: AuthenticatedAdminProgressRoute,
    AuthenticatedAdminPurchasesRoute: AuthenticatedAdminPurchasesRoute,
    AuthenticatedAdminReviewsRoute: AuthenticatedAdminReviewsRoute,
    AuthenticatedAdminStatsRoute: AuthenticatedAdminStatsRoute,
    AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,
    AuthenticatedAdminCoursesCreateRoute: AuthenticatedAdminCoursesCreateRoute,
    AuthenticatedAdminCoursesFaqRoute: AuthenticatedAdminCoursesFaqRoute,
    AuthenticatedAdminCoursesInstructorNotesRoute:
      AuthenticatedAdminCoursesInstructorNotesRoute,
    AuthenticatedAdminCouponsIndexRoute: AuthenticatedAdminCouponsIndexRoute,
    AuthenticatedAdminCoursesIndexRoute: AuthenticatedAdminCoursesIndexRoute,
    AuthenticatedAdminCoursesCourseIdEditRoute:
      AuthenticatedAdminCoursesCourseIdEditRoute,
  }

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  )

interface AuthenticatedChatRouteChildren {
  AuthenticatedChatChannelIdRoute: typeof AuthenticatedChatChannelIdRoute
  AuthenticatedChatDmConversationIdRoute: typeof AuthenticatedChatDmConversationIdRoute
  AuthenticatedChatSupportCourseSlugRoute: typeof AuthenticatedChatSupportCourseSlugRoute
  AuthenticatedChatSupportNewRoute: typeof AuthenticatedChatSupportNewRoute
}

const AuthenticatedChatRouteChildren: AuthenticatedChatRouteChildren = {
  AuthenticatedChatChannelIdRoute: AuthenticatedChatChannelIdRoute,
  AuthenticatedChatDmConversationIdRoute:
    AuthenticatedChatDmConversationIdRoute,
  AuthenticatedChatSupportCourseSlugRoute:
    AuthenticatedChatSupportCourseSlugRoute,
  AuthenticatedChatSupportNewRoute: AuthenticatedChatSupportNewRoute,
}

const AuthenticatedChatRouteWithChildren =
  AuthenticatedChatRoute._addFileChildren(AuthenticatedChatRouteChildren)

interface AuthenticatedCoursesCourseIdLessonsRouteChildren {
  AuthenticatedCoursesCourseIdLessonsLessonIdRoute: typeof AuthenticatedCoursesCourseIdLessonsLessonIdRoute
}

const AuthenticatedCoursesCourseIdLessonsRouteChildren: AuthenticatedCoursesCourseIdLessonsRouteChildren =
  {
    AuthenticatedCoursesCourseIdLessonsLessonIdRoute:
      AuthenticatedCoursesCourseIdLessonsLessonIdRoute,
  }

const AuthenticatedCoursesCourseIdLessonsRouteWithChildren =
  AuthenticatedCoursesCourseIdLessonsRoute._addFileChildren(
    AuthenticatedCoursesCourseIdLessonsRouteChildren,
  )

interface AuthenticatedCoursesCourseIdRouteChildren {
  AuthenticatedCoursesCourseIdLessonsRoute: typeof AuthenticatedCoursesCourseIdLessonsRouteWithChildren
}

const AuthenticatedCoursesCourseIdRouteChildren: AuthenticatedCoursesCourseIdRouteChildren =
  {
    AuthenticatedCoursesCourseIdLessonsRoute:
      AuthenticatedCoursesCourseIdLessonsRouteWithChildren,
  }

const AuthenticatedCoursesCourseIdRouteWithChildren =
  AuthenticatedCoursesCourseIdRoute._addFileChildren(
    AuthenticatedCoursesCourseIdRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRoute
  AuthenticatedChatRoute: typeof AuthenticatedChatRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedDataExportRoute: typeof AuthenticatedDataExportRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedPurchasesRoute: typeof AuthenticatedPurchasesRoute
  AuthenticatedSyncStatusRoute: typeof AuthenticatedSyncStatusRoute
  AuthenticatedCoursesCourseIdRoute: typeof AuthenticatedCoursesCourseIdRouteWithChildren
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,
  AuthenticatedChatRoute: AuthenticatedChatRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedDataExportRoute: AuthenticatedDataExportRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedPurchasesRoute: AuthenticatedPurchasesRoute,
  AuthenticatedSyncStatusRoute: AuthenticatedSyncStatusRoute,
  AuthenticatedCoursesCourseIdRoute:
    AuthenticatedCoursesCourseIdRouteWithChildren,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface SupportSupportTicketEditRouteRouteChildren {
  SupportSupportTicketEditIndexRoute: typeof SupportSupportTicketEditIndexRoute
}

const SupportSupportTicketEditRouteRouteChildren: SupportSupportTicketEditRouteRouteChildren =
  {
    SupportSupportTicketEditIndexRoute: SupportSupportTicketEditIndexRoute,
  }

const SupportSupportTicketEditRouteRouteWithChildren =
  SupportSupportTicketEditRouteRoute._addFileChildren(
    SupportSupportTicketEditRouteRouteChildren,
  )

interface SupportRouteRouteChildren {
  SupportCreateTicketRoute: typeof SupportCreateTicketRoute
  SupportIndexRoute: typeof SupportIndexRoute
  SupportSupportTicketEditRouteRoute: typeof SupportSupportTicketEditRouteRouteWithChildren
  SupportSupportTicketIndexRoute: typeof SupportSupportTicketIndexRoute
}

const SupportRouteRouteChildren: SupportRouteRouteChildren = {
  SupportCreateTicketRoute: SupportCreateTicketRoute,
  SupportIndexRoute: SupportIndexRoute,
  SupportSupportTicketEditRouteRoute:
    SupportSupportTicketEditRouteRouteWithChildren,
  SupportSupportTicketIndexRoute: SupportSupportTicketIndexRoute,
}

const SupportRouteRouteWithChildren = SupportRouteRoute._addFileChildren(
  SupportRouteRouteChildren,
)

interface EducationCoursesCourseRouteRouteChildren {
  EducationCoursesCourseIndexRoute: typeof EducationCoursesCourseIndexRoute
}

const EducationCoursesCourseRouteRouteChildren: EducationCoursesCourseRouteRouteChildren =
  {
    EducationCoursesCourseIndexRoute: EducationCoursesCourseIndexRoute,
  }

const EducationCoursesCourseRouteRouteWithChildren =
  EducationCoursesCourseRouteRoute._addFileChildren(
    EducationCoursesCourseRouteRouteChildren,
  )

interface EducationCoursesRouteRouteChildren {
  EducationCoursesCourseRouteRoute: typeof EducationCoursesCourseRouteRouteWithChildren
  EducationCoursesIndexRoute: typeof EducationCoursesIndexRoute
}

const EducationCoursesRouteRouteChildren: EducationCoursesRouteRouteChildren = {
  EducationCoursesCourseRouteRoute:
    EducationCoursesCourseRouteRouteWithChildren,
  EducationCoursesIndexRoute: EducationCoursesIndexRoute,
}

const EducationCoursesRouteRouteWithChildren =
  EducationCoursesRouteRoute._addFileChildren(
    EducationCoursesRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authRouteRoute: authRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  SupportRouteRoute: SupportRouteRouteWithChildren,
  CookiesRoute: CookiesRoute,
  DownloadsRoute: DownloadsRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  VerifyCourseWishlistRoute: VerifyCourseWishlistRoute,
  EducationCoursesRouteRoute: EducationCoursesRouteRouteWithChildren,
  BlogSlugRoute: BlogSlugRoute,
  BlogIndexRoute: BlogIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
